import { drawing, geometry } from '@progress/kendo-drawing';
import { Element } from './Element.js';
import { AutoSizeableMixin } from './AutoSizeableMixin.js';
import { isNumber } from '../utils/functions.js';
import { deepExtend } from '../utils/deep-extend.js';

class Group extends Element {
    constructor(options) {
        options = deepExtend({ autoSize: false }, options);
        super(options);
        this.children = [];
        this._childrenChange = false;
        // Bind mixin methods to current instance
        this._setScale = AutoSizeableMixin._setScale.bind(this);
        this._setTranslate = AutoSizeableMixin._setTranslate.bind(this);
        this._initSize = AutoSizeableMixin._initSize.bind(this);
        this._updateSize = AutoSizeableMixin._updateSize.bind(this);
        this.drawingElement = new drawing.Group();
        this._initSize();
    }
    append(visual) {
        this.drawingElement.append(visual.drawingContainer());
        this.children.push(visual);
        this._childrenChange = true;
    }
    ;
    remove(visual) {
        if (this._remove(visual)) {
            this._childrenChange = true;
        }
    }
    _remove(visual) {
        const index = this.children.indexOf(visual);
        if (index >= 0) {
            this.drawingElement.removeAt(index);
            this.children.splice(index, 1);
            return true;
        }
    }
    clear() {
        this.drawingElement.clear();
        this.children = [];
        this._childrenChange = true;
    }
    toFront(visuals) {
        let visual;
        for (let i = 0; i < visuals.length; i++) {
            visual = visuals[i];
            if (this._remove(visual)) {
                this.append(visual);
            }
        }
    }
    // TO DO: add drawing group support for moving and inserting children
    toBack(visuals) {
        this._reorderChildren(visuals, 0);
    }
    toIndex(visuals, indices) {
        this._reorderChildren(visuals, indices);
    }
    _reorderChildren(visuals, indices) {
        const group = this.drawingElement;
        const drawingChildren = group.children.slice(0);
        const children = this.children;
        const fixedPosition = isNumber(indices);
        let i, index, toIndex, drawingElement, visual;
        for (i = 0; i < visuals.length; i++) {
            visual = visuals[i];
            drawingElement = visual.drawingContainer();
            index = children.indexOf(visual);
            if (index >= 0) {
                drawingChildren.splice(index, 1);
                children.splice(index, 1);
                toIndex = fixedPosition ? indices : indices[i];
                drawingChildren.splice(toIndex, 0, drawingElement);
                children.splice(toIndex, 0, visual);
            }
        }
        group.clear();
        group.append(...drawingChildren);
    }
    redraw(options) {
        if (options) {
            if (this._childrenChange) {
                this._childrenChange = false;
                if (!this._updateSize(options)) {
                    this._initSize();
                }
            }
            else {
                this._updateSize(options);
            }
            super.redraw(options);
        }
    }
    _boundingBox() {
        const children = this.children;
        let boundingBox;
        let visual, childBoundingBox;
        for (let i = 0; i < children.length; i++) {
            visual = children[i];
            if (visual.visible() && visual._includeInBBox !== false) {
                childBoundingBox = visual.drawingContainer().clippedBBox(null);
                if (childBoundingBox) {
                    if (boundingBox) {
                        boundingBox = geometry.Rect.union(boundingBox, childBoundingBox);
                    }
                    else {
                        boundingBox = childBoundingBox;
                    }
                }
            }
        }
        return boundingBox;
    }
}

export { Group };
